'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PAY_PICKUP_ID = exports.PAY_PICKUP_SLUG = exports.PAY_COURIER_ID = exports.PAY_COURIER_SLUG = undefined;
exports.isMobileDevice = isMobileDevice;
exports.validateNumeric = validateNumeric;
exports.checkPictureFirstPreview = checkPictureFirstPreview;
exports.checkPictureFirstUrl = checkPictureFirstUrl;
exports.checkPicture = checkPicture;
exports.getCheck = getCheck;
exports.getCheckByOrder = getCheckByOrder;
exports.getClassColorByColorId = getClassColorByColorId;
exports.getCurrentThemeByColorId = getCurrentThemeByColorId;
exports.getPipoPageOnProcessInput = getPipoPageOnProcessInput;
exports.getPipoPageOnApiPay = getPipoPageOnApiPay;
exports.isInt = isInt;
exports.sortCategoryBylength = sortCategoryBylength;
exports.stripTags = stripTags;
exports.cutText = cutText;
exports.diffObjects = diffObjects;
exports.replaceCharToArrayIndex = replaceCharToArrayIndex;

var _config = require('config/config');

var config = _interopRequireWildcard(_config);

var _config2 = require('config/config.pipo');

var _constants = require('api/constants');

var _lodash = require('lodash');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Created by maximus on 13.12.16.
 */

var PAY_COURIER_SLUG = exports.PAY_COURIER_SLUG = 'i_bonus_pay_courier';
var PAY_COURIER_ID = exports.PAY_COURIER_ID = 149;
var PAY_PICKUP_SLUG = exports.PAY_PICKUP_SLUG = 'i_bonus_pay_pickup';
var PAY_PICKUP_ID = exports.PAY_PICKUP_ID = 150;

/**
 * Определяем, является ли устройство, с которого открыта страница, мобильным
 * @returns {boolean}
 */
function isMobileDevice() {
    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    );
}

/**
 * Только цифры 0-9 или пустая строка
 * @returns {boolean}
 */
function validateNumeric(value) {
    return (/^\d+$/.test(value) || value === ''
    );
}

function checkPictureFirstPreview(pictures) {
    var pictureUrl = '';
    if (pictures && pictures[0]) {
        if (pictures[0].preview_url) {
            pictureUrl = pictures[0].preview_url;
        } else if (pictures[0].url) {
            pictureUrl = pictures[0].url;
        }
    }
    return pictureUrl;
}

function checkPictureFirstUrl(pictures) {
    if (pictures && pictures[0]) {
        if (pictures[0].url) {
            return pictures[0].url;
        } else if (pictures[0].preview_url) {
            return pictures[0].preview_url;
        }
    }
    return '';
}

/**
 * Проверка на наличие картинки в продукте, подставляет picture_url или url в зависимости от наличия
 * @param pictures массив объектов с картинками
 * @returns {string} строка url картинки
 */
function checkPicture(pictures) {
    var firstUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (firstUrl) {
        return checkPictureFirstUrl(pictures);
    } else {
        return checkPictureFirstPreview(pictures);
    }
}

function getCheck(token) {
    window.open('' + config.apiHost + _constants.IBONUS_PATH_GET_CHECK + '?token=' + token, '', 'scrollbars=1,location=0,height=' + Math.min(500, screen.availHeight) + ',width=' + Math.min(500, screen.availWidth));
}

function getCheckByOrder(order) {
    var iBonusData = null;
    try {
        iBonusData = JSON.parse(order.ibonus_data);
    } catch (e) {
        iBonusData = {};
    }
    if (iBonusData !== null && iBonusData.order_data !== undefined && iBonusData.order_data.receiptUrl !== undefined) {
        var url = iBonusData.order_data.receiptUrl.replace('/purchase/', '/purchase/receipt/');
        window.open('' + url, '', 'scrollbars=1,location=0,height=' + Math.min(500, screen.availHeight) + ',width=' + Math.min(500, screen.availWidth));
    } else if (iBonusData !== null && iBonusData.order_data !== undefined && iBonusData.order_data.publicURL !== undefined && iBonusData.order_data.publicURL !== '/internal_fiscal_check/null/') {
        window.open('' + config.checkUrl + iBonusData.order_data.publicURL, '', 'scrollbars=1,location=0,height=' + Math.min(500, screen.availHeight) + ',width=' + Math.min(500, screen.availWidth));
    } else {

        if (order.token !== undefined) {
            window.open('' + config.apiHost + _constants.IBONUS_PATH_GET_CHECK + '?token=' + order.token, '', 'scrollbars=1,location=0,height=' + Math.min(500, screen.availHeight) + ',width=' + Math.min(500, screen.availWidth));
        } else {
            window.open('' + config.apiHost + _constants.IBONUS_PATH_GET_CHECK + '?token=' + order.view_token, '', 'scrollbars=1,location=0,height=' + Math.min(500, screen.availHeight) + ',width=' + Math.min(500, screen.availWidth));
        }
    }
}

function getClassColorByColorId(colorId) {
    switch (colorId) {
        case 6:
            return 'dark-green-theme';
        case 5:
            return 'navy-theme';
        case 4:
            return 'orange-theme';
        case 3:
            return 'red-theme';
        case 2:
            return 'blue-theme';
        case 7:
            return 'dark-theme';
        default:
        case 1:
            return 'green-theme';
    }
}

function getCurrentThemeByColorId(themeColorId) {

    var result = '';

    switch (themeColorId) {
        case 2:
            result = 'blue';
            break;
        case 4:
            result = 'orange';
            break;
        case 6:
            result = 'dark-green';
            break;
        case 3:
            result = 'red';
            break;
        case 5:
            result = 'navy';
            break;
        case 7:
            result = 'dark-theme';
            break;
        case 1:
        default:
            result = 'cube';
            break;
    }

    return result;
}

function getPipoPageOnProcessInput(paymentId, slug) {
    var additionalFieldName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var additionalFieldText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var orderId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var currency = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'RUR';

    var url = '/api/process_input?operation_id=' + paymentId + '&group_slug=' + slug;
    if (additionalFieldName && additionalFieldText) {
        url += '&' + additionalFieldName + '=' + additionalFieldText;
    }
    if (orderId > 0) {
        var pagePayment = window.location.protocol + '//' + window.location.host + '/payment-order/' + orderId;
        var pageCreate = window.location.protocol + '//' + window.location.host + '/create-order/' + orderId;
        url += '&shop_url=' + encodeURIComponent(pagePayment);
        url += '&success_url=' + encodeURIComponent(pagePayment + '?success=1');
        url += '&fail_url=' + encodeURIComponent(pageCreate + '?fail');
        url += '&currency=' + encodeURIComponent('' + currency);
    }

    return _config2.pipoHost + url;
}

function getPipoPageOnApiPay(_ref) {
    var paymentId = _ref.paymentId,
        _ref$orderId = _ref.orderId,
        orderId = _ref$orderId === undefined ? 0 : _ref$orderId,
        _ref$currency = _ref.currency,
        currency = _ref$currency === undefined ? 'RUR' : _ref$currency,
        _ref$protocol = _ref.protocol,
        protocol = _ref$protocol === undefined ? 'http' : _ref$protocol,
        host = _ref.host;

    var url = '/api/pay/' + paymentId;

    if (orderId > 0) {
        var pagePayment = '';

        if (typeof window !== 'undefined') {
            pagePayment = window.location.protocol + '//' + window.location.host + '/payment-order/' + orderId;
        } else if (protocol && host) {
            pagePayment = protocol + '://' + host + '/payment-order/' + orderId;
        }

        url += '?shop_url=' + encodeURIComponent(pagePayment);
        url += '&success_url=' + encodeURIComponent(pagePayment + '?success=1');
        url += '&fail_url=' + encodeURIComponent(pagePayment + '?fail');
        url += '&currency=' + encodeURIComponent('' + currency);
    }

    return _config2.pipoHost + url;
}

/**
 * Проверка, целое ли число
 * @param num
 * @returns {boolean}
 */
function isInt(num) {
    return (num ^ 0) === num;
}

/**
 * Сортировка категорий по количеству вложеных подкатегорий
 * @param categories массив категорий
 */
function sortCategoryBylength() {
    var categories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return categories;
    categories.sort(function (a, b) {
        var sortA = a.categories && a.categories.length || 0;
        var sortB = b.categories && b.categories.length || 0;

        if (sortA > sortB) {
            return -1;
        }
        if (sortA < sortB) {
            return 1;
        }
        return 0;
    });
    categories.forEach(function (category) {
        if (category['categories']) {
            sortCategoryBylength(category['categories']);
        }
    });
}

/**
 * Метод очистки строки от html тегов
 * @param str
 */
function stripTags() {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    if (str) {
        return str.replace(/<\/?[^>]+>/gi, '');
    }
    return '';
}

// Обрезка текста и подстановка ... в конце
function cutText(text, length) {
    if (typeof text === 'string') {
        if (text.length > length - 3) {
            text = text.substr(0, length) + '...';
        }
    }

    return text;
}

// Сравниваем объект `a` с объектом `b` и возвращаем
// те свойства из `a`, которых нет в `b` или есть, но
// значения отличаются.
// В случае отсутствия различий возвращаем `null`
function diffObjects(a, b) {
    var result = {};

    (0, _lodash.each)(a, function (v, k) {
        if (!(0, _lodash.isEqual)(v, b[k])) {
            result[k] = v;
        }
    });

    return (0, _lodash.isEmpty)(result) ? null : result;
}

/**
 * Проверка строки, на содержанние в ней {n}, и вставка на эти места содержимого массива с соответствующим индексом.
 * @param string
 * @param array
 * @returns {string}
 */
function replaceCharToArrayIndex() {
    var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var array = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    return string.replace(/{(\d)}/, function (str, p1) {
        if (array[p1] !== undefined) {
            return array[p1];
        }
        return '';
    });
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/utils.js
// module id = 31
// module chunks = 0